import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getUserStakes, GetUserStakesParams} from '../api';
import {QUERY__USER_STAKES} from '../queryKeys';
import {Stake} from '../types';

export const useGetUserStakes = <SelectedData = GetListOutput<Stake>>(
  params: GetUserStakesParams,
  options?: QueryOptionsForList<Stake, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__USER_STAKES, params],
    queryFn: () => getUserStakes(params),
    ...options,
  });
